<p><strong [innerHtml]="field.templateOptions.label"></strong></p>

<div>
    <span [innerHtml]="(authService.currentUser | async).user?.unit?.name"></span>
</div>